import React from 'react';
import Card from 'react-bootstrap/Card';
import IphoneContent from "../../assets/images/iphone14-removebg.png";
import SubmitIframeTextDragAds from './SubmitIframeTextDragAds';

function FormsPreviewPhoneTextDragComponentAds({
    data,
    isDevice,
    contentDroppableAreaRender,
    fileList,
    picUrl,
    dataObject,
    AdsTab,
    activeAdSection = "splash",
    banners = [],
    popupPicUrl = "",
    popupFileList = [],
    popupSection = "all"
}) {
    
    let _RenderImage = (qrCodeRef1, isText) => {
        return (
            <div 
                className='w-100 card-mob card-mobile p-1'
                ref={qrCodeRef1 ? qrCodeRef1 : null}
            >
                <SubmitIframeTextDragAds
                    AdsTab={AdsTab}
                    dataObject={dataObject}
                    fileList={fileList}
                    picUrl={picUrl}
                    activeAdSection={activeAdSection}
                    banners={banners}
                    popupPicUrl={popupPicUrl}
                    popupFileList={popupFileList}
                    popupSection={popupSection}
                    contentDroppableAreaRender={contentDroppableAreaRender}
                    isDevice={isDevice}
                    data={data}
                    number={data && data.eventNumber ? data.eventNumber : ""}
                    title={data && data.eventName ? data.eventName : ""}
                    formLink={data && data.formLink ? data && data.formLink : ""}
                />
            </div>
        );
    }

    return (
        <div className='w-100'>
            <Card className='div-phone-ads'>
                <div className='phone-wrapper'>
                    <div className="phone-screen-content">
                        {_RenderImage(null, "")}
                    </div>
                    <img src={IphoneContent} alt="iphone-frame" className="phone-frame" />
                </div>

            </Card>
        </div>
    );
}

export default FormsPreviewPhoneTextDragComponentAds;
